// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Features2_wrapper__c9qOf","card":"Features2_card__1ibWz","main":"Features2_main__10a6f","header":"Features2_header__4iMQx","btn":"Features2_btn__2MSsZ"};